import type { RuntimePrimaryNavigationItem } from '@jukun/platform-sdk/auth';
import { isFixedPortalPath } from './portalNavigation';

const NAVIGATION_CODE = /^[A-Z][A-Z0-9_]{1,159}$/;

export function authorizedRuntimePrimaryNavigation(
  items: readonly RuntimePrimaryNavigationItem[],
  permissionCodes: readonly string[],
): readonly RuntimePrimaryNavigationItem[] {
  if (!Array.isArray(items)) throw new Error('子应用一级导航注册无效');
  if (!items.length) return Object.freeze([]);
  const permissions = new Set(permissionCodes);
  const codes = new Set<string>();
  const normalized = items.map(item => {
    const code = item?.code?.trim();
    const label = item?.label?.trim();
    if (
      !item || typeof item !== 'object'
      || Object.keys(item).some(key => !['code', 'label', 'order'].includes(key))
      || !code || !NAVIGATION_CODE.test(code)
      || !label
      || !Number.isInteger(item.order)
      || !Number.isFinite(item.order)
      || codes.has(code)
    ) {
      throw new Error('子应用一级导航注册无效');
    }
    codes.add(code);
    return Object.freeze({ code, label, order: item.order });
  });
  return Object.freeze(normalized
    .filter(item => permissions.has(item.code))
    .sort((left, right) => left.order - right.order
      || left.code.localeCompare(right.code)));
}

export function shouldRetainRuntimePrimaryNavigation(
  applicationCode: string,
  currentApplicationCode: string | undefined,
  pathname: string,
  items: readonly RuntimePrimaryNavigationItem[],
  hasStableSnapshot = false,
) {
  return items.length === 0
    && (hasStableSnapshot
      || (applicationCode === currentApplicationCode && isFixedPortalPath(pathname)));
}
